import { render, staticRenderFns } from "./DonadoresForm.vue?vue&type=template&id=6fbd6767"
import script from "./DonadoresForm.vue?vue&type=script&lang=js"
export * from "./DonadoresForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports